import './App.css';
import React from 'react';

function App() {
  return (
    <>
      <div className='secao-inicial espacamento'>
        <p className='title1 secondaryText center' id='boas-vindas' >Boas-vindas ao</p>
        <img src='logo-viii-encantarte.svg' id='logo-encantarte' alt=""/>
        <div className='grupo-imagens'>
          <img src='Mesas.png' className='imagem-circulo' alt=""/>
          <img src='Tintino.png' className='imagem-circulo' alt=""/>
        </div>
        <p className='title3 lightestText center' >28 e 29 de Setembro de 2024</p>
      </div>
      <div className='secao-vinha espacamento'>
        <div className='secao-vinha-info'>
          <p className='title2 lightText'>O EncantArte</p>
          <br/>
          <p className='body1 lightText '>
            É um evento anual de promoção da Arte Espírita organizado pelo <strong>Centro Espírita Vinha de Luz</strong>, localizado na Comunidade Braúnas em Justinópolis, Ribeirão das Neves. 
            <br/><br/>
            Além de fomentar com qualidade a cena cultural-artística de Belo Horizonte, o evento também visa arrecadar recursos financeiros com a venda dos ingressos para a manutenção e melhoria dos trabalhos que a instituição religiosa vem desempenhando na carente região em que está inserida.
          </p>
          <br/>
          <br/>
          <br/>
          <p className='title2 lightText'>Conheça o C.E. Vinha de Luz</p>
          <br/>
          <p className='body2 lightText'>Reuniões públicas</p>
          <ul>
            <li className='body1 lightText'>Segunda a quarta de 20:00h às 21:30h</li>
            <li className='body1 lightText'>Segunda a sábado de 07:30h às 08:30h</li>
            <li className='body1 lightText'>Sábado de 17:00h às 18:30h</li>
            <li className='body1 lightText'>Domingo de 08:30h às 11:30h</li>
          </ul>
          <br/>
          <p className='body2 lightText'>Endereço</p>
          <p className='body1 lightText'>Av. Gávea, 493 - Urca (Justinópolis), Ribeirão das Neves</p>
          <br/>
          <p className='body2 lightText'>Contato</p>
          <p className='body1 lightText'>Cida (31) 99709-4064 / Jacques (31) 98735-9273 / Patrícia (31) 99968-5752</p>
        </div>
        <img src='imagens-vinha.png' id='imagens-vinha' alt=""/>
      </div>
      <div className='secao-sabado'>
        <div className='conteudo-apresentacao espacamento'>
          <div className='header-apresentacao'>
            <img src='Mesas.png' className='img-apresentacao' alt=""/>
            <div className='header-apresentacao-info'>
              <div className='wrapper-data'>
                <p className='headline1 lightText'>28</p>
                <div>
                  <p className='title2 lightText'>Sábado</p>
                  <p className='subtitle1 primaryText'>20:00h</p>
                </div>
              </div>
              <div>
                <p className='title1 primaryText'>As Mesas Girantes</p>
                <p className='title2 primaryText'>Cia. Espírita Laboro</p>
              </div>
            </div>
          </div>
          <p className='title3 primaryText center'>"Como quer que seja, as mesas girantes representarão sempre o ponto de partida da  Doutrina Espírita." (Allan Kardec)</p>
          <p className='body1 primaryText center'>
            Em cena uma trupe que relata as manifestações das mesas girantes, ocorridas no século XIX e que constituem como se refere Allan Kardec, no ponto de partida da Doutrina Espírita.
          </p>
          <p className='body1 primaryText center'>
            Com leveza e humor e espetáculo busca despertar o interesse sobre fatos que marcaram o início de uma nova fase para a humanidade: os desencarnados comunicando-se com os desencarnados.
          </p>
          <p className='body1 primaryText center'>
            "Há espíritos?" com a interrogação de Allan Kardec iniciamos a encenação.<br/>A resposta? Assista e verás.
          </p>
          <br/><br/>
          <p className='subtitle3 primaryText center'>Ficha Técnica</p>
          <p className='body3 primaryText center'>Texto: Adriano Alves<br/>Figurinos: Neuza Alves, Adriano Alves<br/>Cenário: Felício Alves, Marcos Aurélio<br/>Músicas: Cia. Espírita Laboro, Movimento Espírita<br/>Elenco: Marcos Aurélio, Daniela Tonidandel, Rafaela Marques, Bráulio Frederico, Vilmar Vilaça, Erica Veloso</p>
        </div>
        <div className='area-participacao'>
          <div className='item-participacao'>
            <img src='logo-laboro.png' className='img-participacao' alt=""/>
            <div className='texto-participacao'>
              <p className='subtitle1 primaryText'>Cia. Espírita Laboro</p>
              <p className='body1 primaryText'>A Cia Espírita Laboro nasce
em 1996 movida pelo ideal
espírita com uma peça que
narrava, de forma leve e bem-humorada, as manifestações
das Mesas Girantes, ocorridas
no século XIX.<br/>A partir daí, a enorme vontade no coração dos participantes
tem sido o motor de um trabalho contínuo de aperfeiçoamento que
tem levado a arte espírita para várias cidades de Minas Gerais e
de outros estados do Brasil. </p>
            </div>
          </div>
        </div>
      </div>
      <div className='secao-domingo'>
        <div className='conteudo-apresentacao espacamento'>
          <div className='header-apresentacao'>
            <img src='Tintino.png' className='img-apresentacao' alt=""/>
            <div className='header-apresentacao-info'>
              <div className='wrapper-data'>
                <p className='headline1 lightestText'>29</p>
                <div>
                  <p className='title2 lightestText'>Domingo</p>
                  <p className='subtitle1 primaryText'>19:30h</p>
                </div>
              </div>
              <div>
                <p className='title1 primaryText'>Tintino</p>
                <p className='title2 primaryText'>GED Transformarte convida GED Iluminar e Núcleo Bella Danças</p>
              </div>
            </div>
          </div>
          <p className='title3 primaryText center'>Uma história real contada através da dança...</p>
          <p className='body1 primaryText center'>
          O espetáculo Tintino narra, a saga autêntica de um palhaço sensível e afetuoso que distribuiu na Terra coragem, esperança, paz e alegria. Conta  também as lindas surpresas que o aguardam no mundo espiritual, onde recebe o salário dos Céus pela sublimação da arte de levar a alegria singela aos corações que a Providência Divina lhe enviava!
          </p>
          <p className='body1 primaryText center'>
          Baseado no livro de Francisca Clotilde/Chico Xavier.
          </p>
          <br/><br/>
          <p className='subtitle3 primaryText center'>Ficha Técnica</p>
          <p className='body3 primaryText center'>Livro base: Tintino, o espetáculo continua<br/>Figurinos: Magno Adam<br/>Cenário: Magno Adam<br/>Músicas: Instrumentais diversas<br/>Elenco: Ana Flávia Grossi Melo, Anna Júlia Vital Morais, Ana Luisa Silva Santos, Lays Aline da Silva, Maria Alice Alves, Eloá Batista Azevedo, Laura Magalhães Ribeiro, Isabela Magalhães Ribeiro, Melissa Barros Vilela, Yumi Jari Lopes, Walquíria Vital dos Santos, Larissa Lopes M. O.  Rezende, Thayllane Luiza dos Santos Rodrigues, Ana Júlia Almeida, Francielly Silva Santos, Maria Eduarda Santos, Maria Luísa dos Santos, Maria Vitória Oliveira, Dilene Vilela, Ana Luísa Martins, Douglas Pereira, Serlena Barros, Ivy Lopes, Miriam Faria.</p>
        </div>
        <div className='area-participacao' style={{paddingBottom: '8rem'}}>
          <div className='item-participacao'>
            <img src='logo-transformarte.png' className='img-participacao' alt=""/>
            <div className='texto-participacao'>
              <p className='subtitle1 primaryText'>Grupo Espírita de Dança Transformarte</p>
              <p className='body1 primaryText'>O Grupo Espírita de Dança Transformarte foi fundado em abril de 2011 e está vinculado ao trabalho de assistência social do Centro Espírita Amor ao Próximo, Ouro Branco, MG. 
              O objetivo do grupo é usar a linguagem da dança, iluminada pelos conhecimentos trazidos pela Doutrina Espírita para promover o autoconhecimento e incentivar a transformação moral de todos envolvidos no trabalho. Atualmente contamos com aproximadamente 30 bailarinos e bailarinas entre 2 e 59 anos!</p>
            </div>
          </div>
          <p className="subtitle2 primaryText">Participação especial</p>
          <div className='item-participacao item-direita'>
            <div className='texto-participacao-direita'>
              <p className='subtitle1 primaryText'>Grupo Espírita de Dança Iluminar</p>
              <p className='body1 primaryText'>Desde 2008 o Iluminar difunde a Dança Espírita em diversas cidades mineiras e do Brasil. O grupo tem como principal objetivo contribuir no processo de aprimoramento moral e espiritual das pessoas, além de promover a divulgação da mensagem Espírita através da dança.</p>
            </div>
            <img src='logo-iluminar.png' className='img-participacao' alt=""/>
          </div>
          <div className='item-participacao'>
            <img src='logo-bella-dancas.png' className='img-participacao' alt=""/>
            <div className='texto-participacao'>
              <p className='subtitle1 primaryText'>Núcleo Bella Danças</p>
              <p className='body1 primaryText'>Há 12 anos, em um pequeno espaço que antes era uma lavanderia, uma menina iniciou seu sonho de formar um grupo de dança. Com um camarim improvisado e espelhos feitos de CDs, ela orou para ter quatro integrantes. Porém, Deus a surpreendeu com quase 40 alunas. O grupo cresceu rapidamente, levando à mudança para um espaço maior e mais adequado. O nome da escola evoluiu, refletindo sua nova fase. Hoje, olhando para o início humilde, a escola de dança celebra cada conquista, reconhecendo que paixão e fé transformaram um simples sonho em algo grandioso.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
